(() => {
  // Mobile drawer
  const menuToggle = document.querySelector(".menu-toggle");
  const drawer = document.getElementById("mobile-drawer");
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
    menuToggle?.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
  };
  menuToggle?.addEventListener("click", () => {
    if (!drawer) return;
    const open = drawer.classList.toggle("open");
    drawer.setAttribute("aria-hidden", open ? "false" : "true");
    menuToggle.setAttribute("aria-expanded", open ? "true" : "false");
    document.body.style.overflow = open ? "hidden" : "";
  });
  drawer?.querySelectorAll("[data-drawer-close]").forEach((el) => {
    el.addEventListener("click", closeDrawer);
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && drawer?.classList.contains("open")) {
      closeDrawer();
    }
  });
  document.querySelectorAll(".drawer-trigger").forEach((btn) => {
    btn.addEventListener("click", () => {
      const sub = btn.nextElementSibling;
      const isOpen = sub?.classList.toggle("open");
      btn.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  });

  // Mobile search overlay
  const searchOverlay = document.getElementById("search-overlay");
  document.querySelectorAll("[data-search-open]").forEach((el) => el.addEventListener("click", () => {
    if (!searchOverlay) return;
    searchOverlay.hidden = false;
    const input = searchOverlay.querySelector("[data-predictive-search-input]");
    window.requestAnimationFrame(() => input?.focus());
    document.body.style.overflow = "hidden";
  }));
  const closeSearchOverlay = () => {
    if (!searchOverlay) return;
    searchOverlay.hidden = true;
    document.body.style.overflow = "";
  };
  document.querySelectorAll("[data-search-close]").forEach((el) => el.addEventListener("click", closeSearchOverlay));
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && searchOverlay && !searchOverlay.hidden) {
      closeSearchOverlay();
    }
  });

  const scrollTrackTo = (track, destination, duration = 800) => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      track.scrollLeft = destination;
      return;
    }

    const start = track.scrollLeft;
    const distance = destination - start;
    const startedAt = performance.now();
    const easeInOut = (progress) => progress < 0.5
      ? 2 * progress * progress
      : 1 - ((-2 * progress + 2) ** 2) / 2;

    const animate = (now) => {
      const progress = Math.min((now - startedAt) / duration, 1);
      track.scrollLeft = start + distance * easeInOut(progress);
      if (progress < 1) requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  };

  document.querySelectorAll(".mrbr-hero").forEach((heroSection) => {
    const heroTrack = heroSection.querySelector("[data-hero-track]");
    if (!heroTrack) return;

    const prevBtn = heroSection.querySelector("[data-hero-prev]");
    const nextBtn = heroSection.querySelector("[data-hero-next]");
    const dots = [...heroSection.querySelectorAll(".hero-dot")];
    const getSlides = () => [...heroTrack.querySelectorAll(".hero-slide")];
    const getSlideWidth = () => heroTrack.clientWidth || 1;

    const updateDots = () => {
      const idx = Math.round(heroTrack.scrollLeft / getSlideWidth());
      dots.forEach((d, i) => d.classList.toggle("active", i === idx));
    };

    heroTrack.addEventListener("scroll", updateDots, { passive: true });

    dots.forEach((dot, i) => {
      dot.addEventListener("click", () => {
        scrollTrackTo(heroTrack, getSlideWidth() * i);
      });
    });

    const goToSlide = (direction) => {
      const slides = getSlides();
      if (slides.length <= 1) return;
      const currentIdx = Math.round(heroTrack.scrollLeft / getSlideWidth());
      let targetIdx = currentIdx + direction;
      if (targetIdx < 0) targetIdx = slides.length - 1;
      if (targetIdx >= slides.length) targetIdx = 0;
      scrollTrackTo(heroTrack, getSlideWidth() * targetIdx);
    };

    prevBtn?.addEventListener("click", () => goToSlide(-1));
    nextBtn?.addEventListener("click", () => goToSlide(1));

    const isAutoplay = heroSection.dataset.autoplay === "true";
    const speedSeconds = parseInt(heroSection.dataset.speed || "3", 10);
    let autoplayTimer = null;

    const startAutoplay = () => {
      if (!isAutoplay || getSlides().length <= 1) return;
      stopAutoplay();
      autoplayTimer = setInterval(() => goToSlide(1), speedSeconds * 1000);
    };

    const stopAutoplay = () => {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    };

    startAutoplay();
  });

  // Product and category rails
  const initRails = () => {
    document.querySelectorAll('[data-mrbr-rail]').forEach((rail) => {
      if (rail.dataset.initialized === 'true') return;
      const shell = rail.parentElement;
      const track = shell?.querySelector('[data-rail-track]');
      const prev = rail.querySelector('[data-rail-prev]');
      const next = rail.querySelector('[data-rail-next]');
      if (!track || !prev || !next) return;

      const getStep = () => {
        const item = track.firstElementChild;
        const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
        return (item?.getBoundingClientRect().width || track.clientWidth) + gap;
      };
      const update = () => {
        const maximum = Math.max(track.scrollWidth - track.clientWidth - 1, 0);
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= maximum;
      };
      const goForward = () => {
        const maximum = Math.max(track.scrollWidth - track.clientWidth - 1, 0);
        const destination = track.scrollLeft >= maximum ? 0 : Math.min(maximum, track.scrollLeft + getStep());
        scrollTrackTo(track, destination);
      };
      let autoplayTimer = null;
      const startAutoplay = () => {
        if (track.dataset.railAutoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        window.clearInterval(autoplayTimer);
        autoplayTimer = window.setInterval(goForward, 5500);
      };
      const stopAutoplay = () => {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      };

      prev.addEventListener('click', () => scrollTrackTo(track, Math.max(0, track.scrollLeft - getStep())));
      next.addEventListener('click', () => scrollTrackTo(track, Math.min(track.scrollWidth, track.scrollLeft + getStep())));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('mouseenter', stopAutoplay);
      track.addEventListener('mouseleave', startAutoplay);
      track.addEventListener('focusin', stopAutoplay);
      track.addEventListener('focusout', startAutoplay);
      track.addEventListener('touchstart', stopAutoplay, { passive: true });
      track.addEventListener('touchend', startAutoplay, { passive: true });
      new ResizeObserver(update).observe(track);
      rail.dataset.initialized = 'true';
      update();
      startAutoplay();
    });
  };
  initRails();
  document.addEventListener('shopify:section:load', initRails);

  // Collection predictive search runs once, including after Shopify section updates.
  const initCollectionSearch = () => {
    document.querySelectorAll('[data-predictive-search-form]').forEach((form) => {
      if (form.dataset.initialized === 'true') return;
      const input = form.querySelector('[data-predictive-search-input]');
      const clear = form.querySelector('[data-predictive-search-clear]');
      const results = form.querySelector('[data-predictive-search-results]');
      if (!input || !results) return;
      let timer;
      const escapeHTML = (value) => String(value || '').replace(/</g, '&lt;');
      const hide = () => { results.hidden = true; };
      const render = (products, query) => {
        if (!products.length) {
          results.innerHTML = `<div class="predictive-empty">No products found matching "${escapeHTML(query)}".</div>`;
          results.hidden = false;
          return;
        }
        results.innerHTML = `<div class="predictive-heading">Suggested products</div><ul class="predictive-list">${products.map((product) => {
          const image = product.image || product.featured_image?.url || '';
          const price = product.price ? `Rs. ${Number(product.price).toLocaleString('en-IN')}` : '';
          return `<li class="predictive-item"><a href="${product.url}" class="predictive-link">${image ? `<img src="${image}" alt="${escapeHTML(product.title)}" width="54" height="54" class="predictive-thumb" loading="lazy">` : '<div class="predictive-thumb-placeholder"></div>'}<div class="predictive-info"><span class="predictive-vendor">${escapeHTML(product.vendor)}</span><span class="predictive-title">${escapeHTML(product.title)}</span><span class="predictive-sale-price">${price}</span></div></a></li>`;
        }).join('')}</ul><a href="/search?q=${encodeURIComponent(query)}" class="predictive-view-all">View all results for "${escapeHTML(query)}"</a>`;
        results.hidden = false;
      };
      let activeController = null;
      const search = (query) => {
        const value = query.trim();
        if (value.length < 1) return hide();
        results.innerHTML = '<div class="predictive-loading">Searching...</div>';
        results.hidden = false;
        activeController?.abort();
        activeController = new AbortController();
        fetch(`/search/suggest.json?q=${encodeURIComponent(value)}&resources[type]=product&resources[limit]=6`, {
          signal: activeController.signal,
        })
          .then((response) => response.json())
          .then((data) => render(data.resources?.results?.products || [], value))
          .catch((error) => {
            if (error?.name === 'AbortError') return;
            results.innerHTML = '<div class="predictive-empty">Unable to load suggestions. Press enter to search.</div>';
          });
      };
      input.addEventListener('input', () => {
        clearTimeout(timer);
        if (clear) clear.hidden = !input.value;
        timer = window.setTimeout(() => search(input.value), 80);
      });
      input.addEventListener('focus', () => {
        if (input.value.trim().length > 0) search(input.value);
      });
      clear?.addEventListener('click', () => { input.value = ''; clear.hidden = true; results.innerHTML = ''; hide(); input.focus(); });
      document.addEventListener('click', (event) => { if (!form.contains(event.target)) hide(); });
      form.dataset.initialized = 'true';
    });
  };

  const initFacetSearch = () => {
    window.mrbrSearchFacets = (input, itemSelector) => {
      const query = (input.value || '').trim().toLowerCase();
      input.closest('.facets__panel-content')?.querySelectorAll(itemSelector).forEach((item) => {
        item.style.display = (item.dataset.name || '').includes(query) ? '' : 'none';
      });
    };
  };
  initCollectionSearch();
  initFacetSearch();
  document.addEventListener('shopify:section:load', initCollectionSearch);

  // Accordions
  document.querySelectorAll(".acc-trigger").forEach((btn) => {
    btn.addEventListener("click", () => {
      const open = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", open ? "false" : "true");
      btn.nextElementSibling?.classList.toggle("open", !open);
    });
  });

  // PDP Image Thumbs
  document.querySelectorAll(".thumb").forEach((thumb) => {
    thumb.addEventListener("click", () => {
      const main = document.querySelector(".gallery-main img");
      const src = thumb.querySelector("img")?.src;
      if (main && src) main.src = src;
      document.querySelectorAll(".thumb").forEach((t) => t.classList.remove("active"));
      thumb.classList.add("active");
    });
  });

  // Reveal animations
  const revealEls = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add("is-visible");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add("is-visible"));
  }

  const getVariantMediaLabels = (picker) => {
    const selected = [...picker.querySelectorAll('input[type="radio"]:checked, select option:checked')]
      .map((el) => el.value?.trim())
      .filter(Boolean);
    if (!selected.length) return [];
    return [selected.join(' / '), ...selected];
  };

  const findVariantMediaIndex = (labels) => {
    const images = [...document.querySelectorAll('media-gallery img, .product-media-gallery img')];
    for (const label of labels) {
      const exact = images.findIndex((img) => img.alt?.trim() === label);
      if (exact >= 0) return exact;
      const lower = label.toLowerCase();
      const fuzzy = images.findIndex((img) => img.alt?.trim().toLowerCase() === lower);
      if (fuzzy >= 0) return fuzzy;
    }
    return -1;
  };

  const syncVariantMedia = (picker) => {
    const labels = getVariantMediaLabels(picker);
    if (!labels.length) return;

    const imageIndex = findVariantMediaIndex(labels);
    if (imageIndex < 0) return;

    const images = [...document.querySelectorAll('media-gallery img, .product-media-gallery img')];
    const matchedImage = images[imageIndex];
    const slideshow = document.querySelector('slideshow-component');
    const slide = matchedImage?.closest('slideshow-slide');
    const slides = slide ? [...slideshow?.querySelectorAll('slideshow-slide') || []] : [];
    const slideIndex = slide ? slides.indexOf(slide) : imageIndex;

    if (slideshow && slideIndex >= 0) {
      slideshow.select(slideIndex, undefined, { animate: false });
    }

    const stickyImage = document.querySelector('.sticky-add-to-cart__image-img');
    const imageSrc = matchedImage?.currentSrc || matchedImage?.src;
    if (stickyImage && imageSrc) {
      stickyImage.src = imageSrc.replace(/width=\d+/i, 'width=120');
    }
  };

  const initVariantMediaSync = () => {
    document.querySelectorAll('variant-picker[data-template-product-match="true"]').forEach((picker) => {
      if (picker.dataset.mrbrVariantMediaSync === 'true') return;
      picker.addEventListener('change', () => {
        window.requestAnimationFrame(() => syncVariantMedia(picker));
      });
      picker.dataset.mrbrVariantMediaSync = 'true';
      syncVariantMedia(picker);
    });
  };

  initVariantMediaSync();
  document.addEventListener('shopify:section:load', initVariantMediaSync);
})();
